export default {
    searching: 'Buscando...',
    loading: 'Cargando...',
    button_edit: 'Editar',
    button_cancel: 'Cancelar',
    button_close: 'Cercar',
    button_delete: 'Eliminar',
    button_restore: 'Restaurar',
    button_view: 'Vista',
    button_view_board: 'Ver en el tablero',
    button_add: 'Agregar',
    button_revoke: 'Revocar',
    button_finish_workload: 'Finalizar actividad',
    card_not_loaded: 'Lo siento, pero no fue posible cargar el contenido.',
    resources: {
        workload: 'Carga de trabajo'
    },
    total: 'Total',
    yes: 'Sí',
    no: 'No',
    without_category: 'Sin Categoria',
    call: 'Ticket',
    calls: 'Tickets',
    attendance_group_id: 'Grupo de Servicio',
    task: 'Tarea',
    item_checklist: 'Elemento de la lista de verificación',
    tasks: 'Tareas',
    call_archived: 'El ticket ha archivado',
    task_archived: 'Tarefa está archivada',
    most_recent: 'Más Reciente',
    older: 'más Viejo',
    verified: 'Verificado',
    not_verified: 'No Verificado',
    period: 'El Período',
    duration: 'Duración',
    total_time: 'Tiempo Total',
    attendants: 'Acomodadores',
    running_activity: 'Actividad de Carrera',
    main_account_user: 'Usuario de la Cuenta Principal',
    created_at: 'Fecha de Creación',
    author: 'Autor',
    user: 'Usuario',
    filters: 'Filtros',
    no_filter: 'Sin Filtro',
    download_all: 'Descargar Todo',
    unlimited: 'Ilimitado',
    answer: 'Responder',
    accept: 'Aceptar',
    ignore: 'Ignorar',
    refuse: 'Negar',
    no_attendant: 'Sin Asistente',
    time_left: 'Restante {{date}}',
    time_exceeded: 'Excedido {{date}}',
    task_count_zero: '0 Tareas',
    task_count_one: '1 Tarea',
    task_count_other: '{{count}} Tareas',
    ticket_count_zero: '0 Tickets',
    ticket_count_one: '1 Ticket',
    ticket_count_other: '{{count}} Tickets',
    responsible_count_zero: '0 Responsables',
    responsible_count_one: '1 Responsable',
    responsible_count_other: '{{count}} Responsables',
    free: 'Libre',
    is_plan_default: 'Plan estándar',
    days_count_zero: 'Ningún día',
    days_count_one: '1 día',
    days_count_other: '{{count}} dias',
    billing_frequency_month_one: 'mensual',
    billing_frequency_month_other: 'cada {{count}} meses',
    billing_frequency_year: 'anual',
    here: 'aquí',
    added_on: 'Añadido el {{date}}',
    expires_on: 'Vence el {{date}}',
}
